import { gql } from '@apollo/client';

export const QUOTE_FRAGMENT = gql`
  fragment QuoteFields on Quote {
    id
    reference
    status
    source
    contactNom
    contactPrenom
    contactEmail
    contactTelephone
    title
    description
    destination
    travelDateStart
    travelDateEnd
    validUntil
    nbrAdulte
    nbrEnfant
    nbrBebe
    subtotal
    discountPercent
    discountAmount
    taxPercent
    taxAmount
    totalPrice
    currency
    notes
    sentAt
    acceptedAt
    rejectedAt
    convertedToBookingId
    clientId
    agencyId
    createdAt
    updatedAt
    client {
      id
      firstName
      lastName
      email
      phone
    }
    agency {
      id
      name
      logo
    }
    lineItems {
      id
      type
      position
      title
      description
      quantity
      unitPrice
      total
      hotelName
      hotelLocation
      hotelStars
      checkIn
      checkOut
      numberOfNights
      numberOfRooms
      roomType
      mealPlan
      airline
      flightFrom
      flightTo
      departureDate
      returnDate
      flightClass
      flightNumber
      transferFrom
      transferTo
      transferDate
      vehicleType
      providerSource
      providerRefId
      providerData
      createdAt
    }
  }
`;

export const GET_QUOTES = gql`
  ${QUOTE_FRAGMENT}
  query GetQuotes($agencyId: Int!) {
    quotes(agencyId: $agencyId) {
      ...QuoteFields
    }
  }
`;

export const GET_QUOTE = gql`
  ${QUOTE_FRAGMENT}
  query GetQuote($id: Int!) {
    quote(id: $id) {
      ...QuoteFields
    }
  }
`;

export const GET_QUOTE_CHANGE_LOGS = gql`
  query GetQuoteChangeLogs($quoteId: Int!) {
    quoteChangeLogs(quoteId: $quoteId) {
      id
      fieldKey
      label
      oldValue
      newValue
      createdAt
    }
  }
`;

export const SEARCH_PROVIDERS = gql`
  query SearchProviders($input: ProviderSearchInput!) {
    searchProviders(input: $input) {
      providerSource
      providerRefId
      providerData
      type
      title
      description
      price
      currency
      data
    }
  }
`;
